import axios from 'axios';
import i18n from '../i18n';

export const translateError = (e: any, fallback?: string): string => {
  const code = e?.response?.data?.error || e?.message || fallback || 'UPLOAD_ERROR';
  const key = `errors.${code}`;
  const translated = (i18n.t as (k: string) => string)(key);
  return translated !== key ? translated : (fallback || code);
};

const isProd = process.env.NODE_ENV === 'production';
export const API_BASE = isProd
  ? 'https://fotovibe.mx/fotovibe'
  : '/fotovibe';

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const stored = localStorage.getItem('fotovibe_admin');
  if (stored) {
    const admin = JSON.parse(stored);
    if (admin?.sessionToken) {
      config.headers['Authorization'] = `Bearer ${admin.sessionToken}`;
    }
  }
  return config;
});

export const validarCupon = async (codigo: string): Promise<{ valid: boolean; codigo?: string; porcentajeDescuento?: number; message: string }> => {
  const res = await api.post('/descuentos/validar', { codigo });
  return res.data;
};

export const crearOrden = async (body: {
  plan: string;
  originalAmountMxn: number;
  discountPct?: number;
  finalAmountMxn: number;
  couponCode?: string;
  eventName: string;
  eventDate?: string;
  eventDescription?: string;
  moderationEnabled: boolean;
}): Promise<{ ordenId: number }> => {
  const res = await api.post('/admin/ordenes', body);
  return res.data;
};

export const confirmarOrden = async (ordenId: number, paypalOrderId: string): Promise<{ eventId: number }> => {
  const res = await api.post(`/admin/ordenes/${ordenId}/confirmar`, { paypalOrderId });
  return res.data;
};

